import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CurrencyShrap = createSvgIcon(
  <svg width="270" height="266" viewBox="0 0 270 266" fill="none">
    <g fill="currentColor">
      <path d="M56.0645 114.696V178.481L135.058 224.106L202.021 185.518L170.923 170.536L135.058 191.192L84.6656 162.137V128.769L56.0645 114.696ZM214.052 87.4566L135.058 41.8311L68.3221 80.4199L99.6471 95.4014L135.058 74.972L185.45 104.027V136.714L214.052 150.561V87.4566Z" />
      <path d="M134.923 0.696777L249.482 66.8372V180.958H234.06V75.7412L134.923 18.5047L40.141 73.2272L0.730469 52.7291L7.84678 39.047L39.7542 55.6426L134.923 0.696777ZM35.7867 190.214V91.852H20.3646V199.118L134.923 265.259L230.092 210.313L261.999 226.908L269.116 213.226L229.705 192.728L134.923 247.451L35.7867 190.214Z" />
    </g>
  </svg>,
  'CurrencyShrap'
);
